export const formatMoney = (
  value: number | string,
  options: { currency?: boolean } = {}
) => {
  const [integer, decimal] = Number(value || 0)
    .toFixed(2)
    .split('.')
  const formatted = `${integer.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')},${decimal}`

  return options.currency ? `$${formatted}` : formatted
}
